<template>
  <v-container id="eixo-list">
    <v-row>
      <v-col>{{ editId ? "Editar" : "Adicionar novo" }} Grupo</v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field v-model="groupName" label="Nome do Grupo"></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquise..."
          required
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="values"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          :search="search"
          :expanded="expanded"
        >
          <template v-slot:header.habilitado="{ header }">
            <span>
              {{ header.text }}
              <AppYesOrNOCombobox
                :editValue="all"
                :value="'habilitado'"
                @onChange="
                  value = value.map((item) => {
                    return {
                      ...item,
                      habilitado: all.habilitado,
                    };
                  })
                "
              ></AppYesOrNOCombobox>
            </span>
          </template>
          <template v-slot:item="{ item }">
            <tr
              :class="`${
                expanded.length > 0 && item === expanded[0] ? 'expanded' : ''
              }`"
            >
              <td>
                {{ item.text }}
              </td>
              <td>
                <v-btn color="primary" @click="openExpanded(item)">
                  Descrição
                </v-btn>
              </td>
              <td>
                <AppYesOrNOCombobox :editValue="item"></AppYesOrNOCombobox>
              </td>
            </tr>
          </template>

          <template v-slot:expanded-item="{ item }">
            <tr class="description">
              <td colspan="9" class="p-0">
                <ul>
                  <li
                    v-for="(description, index) in item.description"
                    :key="index"
                  >
                    {{ description }}
                  </li>
                </ul>
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <span> Nenhuma Configuração </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col style="text-align: end">
        <v-btn
          @click="cancel()"
          type="submit"
          color="error"
          text
          style="margin-right: 10px"
          >cancelar</v-btn
        >
        <v-btn color="info" @click="saveConfig()" type="submit">salvar</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppYesOrNOCombobox from "./Combobox";
import { groupsAPI } from "../API/groupsAPI";
import { groupsPermissionAPI } from "../API/groupsPermissionAPI";
import { filterConfigText, initialConfig } from "@/modules/configuracao";
import Swal from "sweetalert2";
import { atualUfDefinition } from "@/helpers/utils";
import { radarExecucaoInicial } from "@/modules/radar-execucao/utils/acessoRadar.mjs";

const configOnlyKeys = new Set([
  "exibeNumeroPropostaEmVezMunicipioPropostaId",
]);

export default {
  components: {
    AppYesOrNOCombobox,
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "text", width: "80%" },
        {
          text: "Habilitado",
          value: "habilitado",
          width: "20%",
          sortable: false,
        },
      ],
      initialValue: { ...initialConfig, radarExecucao: radarExecucaoInicial(atualUfDefinition.banco) },
      values: [],
      search: "",
      editId: this.$route.params.id,
      group: {},
      groupName: "",
      expanded: [],
      all: { habilitado: false },
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    removeConfigOnlyValues(values) {
      return Object.fromEntries(
        Object.entries(values).filter(([key]) => !configOnlyKeys.has(key))
      );
    },
    openExpanded(evidenceSlot) {
      if (this.expanded.length > 0) {
        this.expanded.forEach((item, index) => {
          if (item === evidenceSlot) {
            this.expanded.splice(index, 1);
          } else {
            this.expanded = [];
            this.expanded.push(evidenceSlot);
          }
        });
      } else {
        this.expanded.push(evidenceSlot);
      }
    },
    async load() {
      if (this.editId) {
        await this.loadEditValue();
      }
      let t = Object.entries(
        this.removeConfigOnlyValues(this.initialValue)
      ).map((entry) => {
        return { [entry[0]]: entry[1] };
      });

      this.values = t
        .map((item) => {
          return {
            habilitado: Object.values(item)[0],
            text:
              filterConfigText(Object.keys(item)[0]) &&
              filterConfigText(Object.keys(item)[0]).text,
            description:
              filterConfigText(Object.keys(item)[0]) &&
              filterConfigText(Object.keys(item)[0]).description,
            id: Object.keys(item)[0],
          };
        })
        .filter((item) => item.text)
        .sort(function (a, b) {
          if (a.text < b.text) {
            return -1;
          }
          if (a.text > b.text) {
            return 1;
          }
          return 0;
        });
    },
    async loadEditValue() {
      this.setLoading(true);
      await groupsAPI.getOne(this.editId).then(async ({ data }) => {
        this.groupName = data.nome;
        this.group = data;
        await groupsPermissionAPI.getByGroup(this.editId).then((permission) => {
          if (permission.data)
            this.initialValue = this.removeConfigOnlyValues({
              ...this.initialValue,
              ...permission.data,
            });
          this.setLoading(false);
        });
      });
    },
    saveConfig() {
      if (!this.groupName) {
        Swal.fire({
          title: "Atenção!",
          text: `Nome do grupo obrigatório!`,
          confirmButtonText: "Ok",
        });
      } else {
        this.setLoading(true);

        var finalValue = {
          ...this.initialValue,
          ...this.values.reduce((a, v) => ({ ...a, [v.id]: v.habilitado }), {}),
        };
        finalValue = this.removeConfigOnlyValues(finalValue);
        if (this.editId) {
          this.edit(finalValue);
        } else {
          this.add(finalValue);
        }
      }
    },
    cancel() {
      this.$router.push("/groups");
    },
    add(finalValue) {
      groupsAPI.create({ nome: this.groupName }).then(() => {
        groupsAPI.getLastGroup().then(({ data }) => {
          finalValue = { ...finalValue, usuarioGrupoId: data.usuarioGrupoId };
          groupsPermissionAPI.create(finalValue).then(() => {
            this.setLoading(false);
            this.$router.push("/groups");
          });
        });
      });
    },
    edit(finalValue) {
      let groupUpdate = {
        ...this.group,
        nome: this.groupName,
        usuarioGrupoId: this.editId,
      };
      groupsAPI.update(groupUpdate).then(() => {
        groupsPermissionAPI.getByGroup(this.editId).then(({ data }) => {
          if (data) {
            groupsPermissionAPI.update(finalValue).then(() => {
              this.setLoading(false);
              this.$router.push("/groups");
            });
          } else {
            finalValue = { ...finalValue, usuarioGrupoId: this.editId };
            groupsPermissionAPI.create(finalValue).then(() => {
              this.setLoading(false);
              this.$router.push("/groups");
            });
          }
        });
      });
    },
  },

  mounted() {
    this.load();
  },

  computed: {
    ...mapGetters(["isFullAdmin", "config"]),
  },
};
</script>
<style scoped lang="scss">
.description {
  background: #edeaea;
  td {
    padding: 0 30px !important;
  }
}
.expanded {
  background: #c9c9c9;
}
button {
  background: #5c8bb9;
  padding: 0.5rem 2rem;
  border-radius: 10px;
  color: #fff;
}
</style>
